import { Button } from '@bwoty-web/ui-kit';
import FakeUi from '../../shared/loaders/FakeUi';

const PriceMatrixSummaryLoader = () => {
  return (
    <div className="iw-price-summary uikit-box">
      <div className="iw-price-summary__top">
        <div className="iw-price-summary__top-inner-wrapper">
          <div className="iw-price-summary__price-and-details-wrapper">
            <div
              className="iw-price-summary__header"
              style={{ height: 28, width: 130 }}
            >
              <FakeUi />
            </div>
          </div>
        </div>
        <Button
          className="iw-price-summary__button"
          disabled
          style={{ height: 37, width: 90 }}
        >
          <span />
        </Button>
      </div>
    </div>
  );
};

export default PriceMatrixSummaryLoader;
